import styled from 'styled-components';

const Wrapper = styled.div`
  & > * {
    z-index: 10000;
  }
`;

export { Wrapper };
